/* eslint-disable warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class AssessmentRoute extends Route {
  // Services
  @service
  dates;

  @service
  session;

  @service
  store;

  model(params) {
    return hash({
      assessment: this.store.findRecord(
        'assessments/assessment',
        params.assessment_id,
      ),
      // `modules` is not used directly, but preloads all modules in one request.
      modules: this.store.query('assessments/module', {
        assessmentId: params.assessment_id,
      }),
      gradeschedules: this.store.findAll('assessments/grade-schedule'),
    });
  }

  setupController(controller) {
    super.setupController(...arguments);

    // Clear out selected modules on load.
    controller.set('selected', []);
  }
}
